import { CancelAssetServicesRequestV26 } from 'src/app/models-v26/wizards/cancel-license-services-request';
import { ActionResponse } from 'src/app/models/action-response';
import { TerminateMultiAssetDueDatesStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/terminate-multi-asset-wizard/init-step/due-date-step';
import { TerminateMultiAssetAssetStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/terminate-multi-asset-wizard/terminate-multi-asset-asset-step/terminate-multi-asset-asset-step-info';
import { TerminateMultiAssetCancelDetailsDataV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/terminate-multi-asset-wizard/terminate-multi-asset-cancel-details-step/terminate-multi-asset-cancel-details-data';
export interface State {
  assetStep: TerminateMultiAssetAssetStepV26;
  dueDatesStep: TerminateMultiAssetDueDatesStepV26;
  cancelDetailsStep: TerminateMultiAssetCancelDetailsDataV26[];
  request: CancelAssetServicesRequestV26;
  response: ActionResponse;
  errorMessage: string;
}

export const initialState: State = {
  assetStep: null,
  dueDatesStep: { deactivationDate: null },
  cancelDetailsStep: null,
  request: null,
  response: null,
  errorMessage: null,
};
